export const FETCHING_MEMBER_REQUESTS = "FETCHING.MEMBER_REQUESTS";
export const FETCHED_MEMBER_REQUESTS = "FETCHED.MEMBER_REQUESTS";
export const SENDING_MEMBER_REQUEST = "SENDING.MEMBER_REQUEST";
export const SEND_MEMBER_REQUEST = "SEND.MEMBER_REQUEST";
export const ERROR_JOIN_REQUEST = "ERROR.MEMBER_REQUEST";

export const UPDATING_MEMBER_REQUESTS_STATUS = "UPDATING_STATUS.MEMBER_REQUESTS";
export const REMOVE_MEMBER_REQUEST = "REMOVE.MEMBER_REQUESTS"; 
export const ERROR_FETCHING_MEMBER_REQUESTS = "ERROR.FETCHING_MEMBER_REQUESTS";
export const ERROR_UPDATING_MEMBER_REQUEST = "ERROR.UPDATE_MEMBER_REQUEST";
 
